import _ from 'lodash';

const isDomainRestricted = (allowedValues, deniedValues) => {
  const GCP_RACKSPACE_COM_DOMAIN_ID = 'C01maxa7l';

  return (
    (allowedValues && !allowedValues?.includes(GCP_RACKSPACE_COM_DOMAIN_ID))
    || (deniedValues && deniedValues?.includes(GCP_RACKSPACE_COM_DOMAIN_ID))
  );
};

const verifyOrgConstraint = (orgPolicyConstraint) => {
  if (!orgPolicyConstraint) {
    return false;
  }
  const { listPolicy = {} } = orgPolicyConstraint;
  const { allValues, allowedValues, deniedValues } = listPolicy;

  if (allValues) return allValues === 'DENY';

  const domainRestrictedStatus = isDomainRestricted(allowedValues, deniedValues);
  return domainRestrictedStatus;
};

export const orgConstraintsValidator = (policies, constraintToValidate) => {
  let orgPolicyConstraint = null;

  for (const policy of policies) {
    if (policy.constraint.includes(constraintToValidate)) {
      orgPolicyConstraint = policy;
      break;
    }
  }
  const orgPolicyConstraintStatus = verifyOrgConstraint(orgPolicyConstraint);
  return Boolean(orgPolicyConstraintStatus);
};

export const userPermissionsValidator = (havePermissions, requiredPermissions) => {
  const missingPermissions = _.differenceWith(requiredPermissions, havePermissions, _.isEqual);
  return Boolean(missingPermissions.length);
};
